// Porteros (tienda v5) — port de maquetas/tienda-v5-porteros.html a JSX.
// Página 10 de Fase 3. Ruta /porteros (+ dev alias). Acento GOLD (toda la maqueta
// de esta página es gold: hero/tiers/proof/CTAs). CSS co-locado bajo .tv5-page-porteros.
//
// Reusa shared: TopNav(gold) / Breadcrumb / Footer(gold) / BottomNav / MiniBar.
// Elementos (maqueta pulida Fase 1): hero + CTA, proof (3), "Cuánto ganás" (2 tiers +
// ejemplo real), "Cómo funciona" (4 pasos, incl. paso 2 'Te validamos 24-48hs'),
// FAQ propia de porteros (6), CTA final.
//
// Nota: el bloque "Bonus Cuadra / 10 vecinos = 5% off" NO va acá — se movió a la
// página Cuadra (pág. 12) por decisión de Fase 1 (ya venía comentado en la maqueta).
// Los CTAs van a /quiero-ser-portero (formulario público de postulación, que ya existe
// en App.jsx). Las postulaciones llegan a /admin/postulaciones-porteros. [fix 24-jul-2026]
import { TopNav, Breadcrumb, Footer, BottomNav, MiniBar } from '../../components/tienda-v5';
import { TV5_ROUTES } from '../../components/tienda-v5/routes';

const PROOF = [
  { num: '$50-100', label: 'por vecino / mes' },
  { num: '0%', label: 'inversión inicial' },
  { num: '100%', label: 'automático' },
];

const TIERS = [
  {
    variant: 'essential',
    tier: 'Kit Essential',
    nombre: 'Solo · Familiar · Hogar+',
    desc: 'Los kits básicos, los más pedidos del barrio.',
    precio: '$50',
    detalle: 'Mientras esté al día con su suscripción.',
  },
  {
    variant: 'premium',
    tier: '★ Kit Premium',
    nombre: 'Dúo · Confort · Exclusive',
    desc: 'Kits con productos premium y regalo mensual.',
    precio: '$100',
    detalle: 'Mientras esté al día con su suscripción.',
  },
];

const EJEMPLO_LINEAS = [
  { label: '8 vecinos con Kit Essential', val: '8 × $50 = $400' },
  { label: '4 vecinos con Kit Premium', val: '4 × $100 = $400' },
];

const PASOS = [
  { n: '1', h: 'Postulate acá', p: 'Llenás el formulario en 2 minutos. Contás dónde trabajás y cuántos apartamentos hay.' },
  { n: '2', h: 'Te validamos', p: 'Chequeamos que el edificio esté en un barrio que cubrimos y confirmamos que sos vos. Te avisamos por WhatsApp en 24-48hs.' },
  { n: '3', h: 'Recibí tu link único', p: 'Cuando quedás aprobado, te mandamos por WhatsApp un link personalizado. Se lo pasás a los vecinos que te preguntan por Limpack.' },
  { n: '4', h: 'Cobrás cada mes', p: 'Cuando llegás a $1.000 acumulados, te transferimos a tu cuenta bancaria. Automático.' },
];

const FAQ_PORTEROS = [
  { q: '¿Cómo cobro?', a: 'Transferencia bancaria a tu cuenta cuando acumulás $1.000. El primer mes queda en custodia 30 días para verificar tu identidad — después, todo automático.' },
  { q: '¿Tengo que manejar plata?', a: 'No. Nunca. El cliente le paga directo a Limpack. Vos solo referís. Nosotros manejamos cobranza, entrega y devoluciones.' },
  { q: '¿Y si el vecino cancela?', a: 'Dejás de ganar por ese vecino desde el mes siguiente. Los meses ya pagados quedan, obvio.' },
  { q: '¿Tengo acceso a la info de los vecinos?', a: 'No. Por Ley 18.331 de protección de datos, vos no ves nombres, teléfonos, direcciones ni consumos. Solo ves cuántos vecinos están activos en Essential y Premium.' },
  { q: '¿Puedo darme de baja?', a: 'Cuando quieras, por WhatsApp o email. Las comisiones ya ganadas se te pagan igual.' },
  { q: '¿Qué pasa si me cambio de edificio?', a: 'Nos avisás y te reasignamos al nuevo. Los vecinos anteriores dejan de generar (obvio) pero mantenés tu cuenta y tu historial.' },
];

export default function Porteros() {
  return (
    <div className="tv5-page-porteros">
      <style>{PORTEROS_CSS}</style>

      <TopNav active="porteros" accent="gold" />
      <Breadcrumb backHref={TV5_ROUTES.home} backLabel="Home" current="Porteros" />

      <main>
        {/* HERO */}
        <section className="pt-hero">
          <span className="pt-eyebrow">🏢 Programa Portero Limpack</span>
          <h1>Ganá cada mes por cada vecino que se suscriba.</h1>
          <p>Vos los ayudás a resolver la limpieza. Nosotros nos ocupamos del resto. Sin invertir nada, sin manejar plata, sin cambiar tu rutina.</p>
          <a href="/quiero-ser-portero" className="pt-hero-cta">Quiero postularme →</a>
        </section>

        {/* PROOF */}
        <div className="pt-proof">
          {PROOF.map((p) => (
            <div className="pt-proof-item" key={p.label}>
              <div className="pt-proof-num">{p.num}</div>
              <div className="pt-proof-label">{p.label}</div>
            </div>
          ))}
        </div>

        {/* CUÁNTO GANÁS */}
        <section className="pt-seccion">
          <h2>Cuánto ganás</h2>
          <p className="pt-seccion-sub">Cobrás mientras el vecino esté suscripto. Si cancela, deja de generar. Simple.</p>

          <div className="pt-tiers">
            {TIERS.map((t) => (
              <div className={`pt-tier${t.variant === 'essential' ? ' pt-tier--essential' : ''}`} key={t.tier}>
                <div className="pt-tier-tag">{t.tier}</div>
                <div className="pt-tier-nombre">{t.nombre}</div>
                <div className="pt-tier-desc">{t.desc}</div>
                <div className="pt-tier-precio-row">
                  <div className="pt-tier-precio">{t.precio}</div>
                  <div className="pt-tier-porvecino">por vecino / mes</div>
                </div>
                <div className="pt-tier-detalle">{t.detalle}</div>
              </div>
            ))}
          </div>

          {/* EJEMPLO REAL */}
          <div className="pt-ejemplo">
            <div className="pt-ejemplo-titulo">💡 Ejemplo real</div>
            <h3>Edificio de 40 apartamentos en Pocitos</h3>
            <div className="pt-ejemplo-lineas">
              {EJEMPLO_LINEAS.map((l) => (
                <div className="pt-ejemplo-linea" key={l.label}>
                  <span className="pt-ejemplo-linea-label">{l.label}</span>
                  <span className="pt-ejemplo-linea-val">{l.val}</span>
                </div>
              ))}
            </div>
            <div className="pt-ejemplo-total">
              <span>💰 Ganás por mes</span>
              <span className="pt-ejemplo-total-num">$800</span>
            </div>
          </div>
        </section>

        {/* CÓMO FUNCIONA */}
        <section className="pt-seccion">
          <h2>Cómo funciona</h2>
          <p className="pt-seccion-sub">4 pasos y ya estás cobrando. Sin manejar plata ni cargar productos.</p>

          <div className="pt-pasos">
            {PASOS.map((p) => (
              <div className="pt-paso" key={p.n}>
                <span className="pt-paso-num">{p.n}</span>
                <h3>{p.h}</h3>
                <p>{p.p}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="pt-seccion">
          <h2>Dudas rápidas</h2>
          <div className="pt-faq">
            {FAQ_PORTEROS.map((f) => (
              <details className="pt-faq-item" key={f.q}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>
        </section>

        {/* CTA FINAL */}
        <div className="pt-cta-fin">
          <h3>Sumate como Portero Limpack</h3>
          <p>2 minutos, sin compromiso. Empezás a cobrar apenas se suscribe tu primer vecino.</p>
          <a href="/quiero-ser-portero" className="pt-cta-fin-btn">Postularme →</a>
        </div>
      </main>

      <MiniBar checkoutHref={TV5_ROUTES.checkout} />
      <Footer accent="gold" />
      <BottomNav active="porteros" />
    </div>
  );
}

const PORTEROS_CSS = `
.tv5-page-porteros {
  --tv5p-navy:#1A3461; --tv5p-teal:#00A8B5; --tv5p-gold:#C5A059; --tv5p-green:#10B981;
  --tv5p-bg:#0A1424; --tv5p-card:rgba(255,255,255,0.04); --tv5p-border:rgba(255,255,255,0.08);
  --tv5p-text:#F8F6F1; --tv5p-muted:rgba(248,246,241,0.65); --tv5p-dim:rgba(248,246,241,0.45);
  --safe-bottom:env(safe-area-inset-bottom, 0px);
  background:var(--tv5p-bg); color:var(--tv5p-text); min-height:100vh; position:relative;
  overflow-x:clip; max-width:100%;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
  padding-bottom:calc(72px + var(--safe-bottom));
}
.tv5-page-porteros::before {
  content:''; position:fixed; inset:0; pointer-events:none; z-index:0;
  background:
    radial-gradient(circle at 20% 10%, rgba(197,160,89,0.12) 0%, transparent 40%),
    radial-gradient(circle at 80% 60%, rgba(0,168,181,0.08) 0%, transparent 40%);
}
.tv5-page-porteros main { position:relative; z-index:1; }
@media (min-width:900px){ .tv5-page-porteros { padding-bottom:0; } }

/* HERO */
.tv5-page-porteros .pt-hero { padding:40px 20px 20px; text-align:center; max-width:900px; margin:0 auto; }
.tv5-page-porteros .pt-eyebrow { display:inline-block; color:var(--tv5p-gold); font-size:11px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; padding:6px 14px; background:rgba(197,160,89,0.1); border:1px solid rgba(197,160,89,0.3); border-radius:999px; margin-bottom:14px; }
.tv5-page-porteros .pt-hero h1 { font-size:clamp(30px, 6.5vw, 52px); font-weight:800; letter-spacing:-0.03em; line-height:1.05; margin-bottom:14px; background:linear-gradient(135deg, var(--tv5p-text) 0%, var(--tv5p-gold) 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-porteros .pt-hero p { color:var(--tv5p-muted); font-size:15px; max-width:560px; margin:0 auto 20px; line-height:1.6; }
.tv5-page-porteros .pt-hero-cta { display:inline-flex; align-items:center; gap:6px; background:linear-gradient(135deg, var(--tv5p-gold) 0%, #D4B370 100%); color:var(--tv5p-navy); padding:14px 28px; border-radius:10px; font-weight:800; font-size:14px; text-decoration:none; box-shadow:0 8px 24px rgba(197,160,89,0.35); min-height:44px; transition:transform 0.2s; }
@media (hover:hover){ .tv5-page-porteros .pt-hero-cta:hover { transform:translateY(-2px); } }

/* PROOF */
.tv5-page-porteros .pt-proof { max-width:900px; margin:0 auto; padding:20px; display:grid; grid-template-columns:repeat(3, 1fr); gap:12px; text-align:center; }
.tv5-page-porteros .pt-proof-item { background:var(--tv5p-card); border:1px solid var(--tv5p-border); border-radius:14px; padding:18px 12px; }
.tv5-page-porteros .pt-proof-num { font-size:clamp(20px, 4vw, 28px); font-weight:900; color:var(--tv5p-gold); letter-spacing:-0.02em; margin-bottom:4px; }
.tv5-page-porteros .pt-proof-label { font-size:11px; color:var(--tv5p-muted); font-weight:600; letter-spacing:0.03em; }

/* SECCIÓN */
.tv5-page-porteros .pt-seccion { padding:40px 20px; max-width:1000px; margin:0 auto; }
.tv5-page-porteros .pt-seccion h2 { font-size:clamp(22px, 4vw, 32px); font-weight:800; letter-spacing:-0.02em; margin-bottom:8px; text-align:center; }
.tv5-page-porteros .pt-seccion-sub { text-align:center; color:var(--tv5p-muted); font-size:14px; margin:0 auto 32px; max-width:500px; line-height:1.5; }

/* TIERS */
.tv5-page-porteros .pt-tiers { display:grid; gap:16px; }
@media (min-width:640px){ .tv5-page-porteros .pt-tiers { grid-template-columns:repeat(2, 1fr); } }
.tv5-page-porteros .pt-tier { background:linear-gradient(135deg, rgba(197,160,89,0.08) 0%, rgba(255,255,255,0.02) 100%); border:1px solid rgba(197,160,89,0.25); border-radius:18px; padding:26px 22px; position:relative; overflow:hidden; transition:transform 0.3s, border-color 0.3s, box-shadow 0.3s; }
@media (hover:hover){ .tv5-page-porteros .pt-tier:hover { transform:translateY(-3px); border-color:var(--tv5p-gold); box-shadow:0 12px 32px rgba(197,160,89,0.15); } }
.tv5-page-porteros .pt-tier--essential { border-color:rgba(0,168,181,0.3); background:linear-gradient(135deg, rgba(0,168,181,0.08) 0%, rgba(255,255,255,0.02) 100%); }
@media (hover:hover){ .tv5-page-porteros .pt-tier--essential:hover { border-color:var(--tv5p-teal); box-shadow:0 12px 32px rgba(0,168,181,0.15); } }
.tv5-page-porteros .pt-tier-tag { font-size:10px; font-weight:800; letter-spacing:0.12em; text-transform:uppercase; color:var(--tv5p-gold); margin-bottom:6px; }
.tv5-page-porteros .pt-tier--essential .pt-tier-tag { color:var(--tv5p-teal); }
.tv5-page-porteros .pt-tier-nombre { font-size:22px; font-weight:800; margin-bottom:4px; letter-spacing:-0.01em; }
.tv5-page-porteros .pt-tier-desc { color:var(--tv5p-muted); font-size:13px; margin-bottom:20px; line-height:1.5; }
.tv5-page-porteros .pt-tier-precio-row { display:flex; align-items:baseline; gap:8px; margin-bottom:6px; }
.tv5-page-porteros .pt-tier-precio { font-size:40px; font-weight:900; letter-spacing:-0.03em; background:linear-gradient(135deg, var(--tv5p-gold) 0%, #E5C687 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-porteros .pt-tier--essential .pt-tier-precio { background:linear-gradient(135deg, var(--tv5p-teal) 0%, #4DCCD8 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-porteros .pt-tier-porvecino { font-size:13px; color:var(--tv5p-muted); }
.tv5-page-porteros .pt-tier-detalle { font-size:12px; color:var(--tv5p-dim); }

/* EJEMPLO */
.tv5-page-porteros .pt-ejemplo { background:linear-gradient(135deg, rgba(16,185,129,0.12) 0%, rgba(197,160,89,0.06) 100%); border:1px solid rgba(16,185,129,0.3); border-radius:20px; padding:28px 22px; margin-top:24px; }
.tv5-page-porteros .pt-ejemplo-titulo { font-size:11px; font-weight:800; letter-spacing:0.12em; text-transform:uppercase; color:#6EE7B7; margin-bottom:10px; }
.tv5-page-porteros .pt-ejemplo h3 { font-size:22px; font-weight:800; margin-bottom:16px; letter-spacing:-0.01em; }
.tv5-page-porteros .pt-ejemplo-lineas { display:grid; gap:10px; margin-bottom:20px; }
.tv5-page-porteros .pt-ejemplo-linea { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:10px 14px; background:rgba(0,0,0,0.2); border-radius:10px; font-size:14px; }
.tv5-page-porteros .pt-ejemplo-linea-label { color:var(--tv5p-muted); }
.tv5-page-porteros .pt-ejemplo-linea-val { font-weight:800; white-space:nowrap; }
.tv5-page-porteros .pt-ejemplo-total { padding:16px 20px; background:rgba(16,185,129,0.15); border:1px solid rgba(16,185,129,0.4); border-radius:12px; display:flex; align-items:center; justify-content:space-between; gap:12px; font-size:15px; font-weight:700; }
.tv5-page-porteros .pt-ejemplo-total-num { font-size:26px; font-weight:900; color:#6EE7B7; letter-spacing:-0.02em; }

/* PASOS */
.tv5-page-porteros .pt-pasos { display:grid; gap:14px; }
@media (min-width:768px){ .tv5-page-porteros .pt-pasos { grid-template-columns:repeat(3, 1fr); } }
.tv5-page-porteros .pt-paso { background:var(--tv5p-card); border:1px solid var(--tv5p-border); border-radius:14px; padding:22px 20px; position:relative; }
.tv5-page-porteros .pt-paso-num { display:inline-flex; align-items:center; justify-content:center; width:32px; height:32px; border-radius:50%; background:rgba(197,160,89,0.15); color:var(--tv5p-gold); border:1px solid rgba(197,160,89,0.3); font-weight:900; font-size:14px; margin-bottom:12px; }
.tv5-page-porteros .pt-paso h3 { font-size:17px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-porteros .pt-paso p { color:var(--tv5p-muted); font-size:13px; line-height:1.5; }

/* FAQ */
.tv5-page-porteros .pt-faq { display:grid; gap:10px; margin-top:20px; }
.tv5-page-porteros .pt-faq-item { background:rgba(255,255,255,0.03); border:1px solid var(--tv5p-border); border-radius:12px; overflow:hidden; transition:border-color 0.2s, background 0.2s; }
.tv5-page-porteros .pt-faq-item[open] { border-color:rgba(197,160,89,0.3); background:rgba(197,160,89,0.05); }
.tv5-page-porteros .pt-faq-item summary { padding:16px 18px; cursor:pointer; font-weight:700; font-size:14px; display:flex; align-items:center; justify-content:space-between; gap:12px; list-style:none; }
.tv5-page-porteros .pt-faq-item summary::-webkit-details-marker { display:none; }
.tv5-page-porteros .pt-faq-item summary::after { content:'+'; font-size:22px; color:var(--tv5p-gold); font-weight:300; flex-shrink:0; transition:transform 0.2s; }
.tv5-page-porteros .pt-faq-item[open] summary::after { transform:rotate(45deg); }
.tv5-page-porteros .pt-faq-item p { padding:0 18px 18px; color:var(--tv5p-muted); font-size:13px; line-height:1.6; }

/* CTA FINAL */
.tv5-page-porteros .pt-cta-fin { max-width:700px; margin:60px auto 0; padding:40px 24px; background:linear-gradient(135deg, var(--tv5p-gold) 0%, #D4B370 100%); border-radius:20px; text-align:center; color:var(--tv5p-navy); box-shadow:0 20px 60px rgba(197,160,89,0.35); }
.tv5-page-porteros .pt-cta-fin h3 { font-size:26px; font-weight:900; margin-bottom:8px; letter-spacing:-0.02em; }
.tv5-page-porteros .pt-cta-fin p { font-size:14px; margin-bottom:24px; opacity:0.85; }
.tv5-page-porteros .pt-cta-fin-btn { display:inline-flex; align-items:center; gap:6px; background:var(--tv5p-navy); color:#fff; padding:16px 32px; border-radius:10px; font-weight:800; font-size:15px; text-decoration:none; min-height:44px; transition:transform 0.2s; }
@media (hover:hover){ .tv5-page-porteros .pt-cta-fin-btn:hover { transform:translateY(-2px); } }

/* Reduced motion */
@media (prefers-reduced-motion:reduce){
  .tv5-page-porteros .pt-hero-cta, .tv5-page-porteros .pt-tier, .tv5-page-porteros .pt-faq-item,
  .tv5-page-porteros .pt-faq-item summary::after, .tv5-page-porteros .pt-cta-fin-btn { transition:none; }
}
`;
